import Vue from "vue";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

import VCalendar from "v-calendar";
import VueCarousel from "vue-carousel";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./directives";
import "./filters";
import "./assets/css/main.css";

/** external plugins */
import Vuelidate from "vuelidate";
import VTooltip from "v-tooltip";

Sentry.init({
  Vue,
  dsn:
   "https://f7f878c8c388ab85a48e637037c93aa5@o1129278.ingest.us.sentry.io/4510482780061696",
  environment: process.env.NODE_ENV,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: [
        "localhost",
        "richiedicarta.valid.tinaba.it",
        "richiedicarta.tinaba.it",
        /^\//
      ]
    })
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  sendDefaultPii: true
});


Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.use(VTooltip, {
  defaultTrigger: window.innerWidth > 768 ? "hover focus click" : "click"
});
Vue.use(VCalendar);
Vue.use(VueCarousel);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
